export default __webpack_public_path__ + "static/media/LMAS.3c09b3b6.png";